import { Link, useParams } from "react-router-dom";
import Incidents from "../Incidents.jsx";

export default function ArchiveSeasonIncidentsDb() {
    const { seasonKey } = useParams();
    const key = String(seasonKey || "").trim() || "active";

    return (
        <>
            <div className="card" style={{ marginBottom: 12 }}>
                <h2 style={{ marginBottom: 8 }}>Archiv {key.toUpperCase()} - Incidents</h2>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Link className="btn" to={`/gt3x/archiv/${key}`}>Zur Season</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/results`}>Results</Link>
                    <Link className="btn" to={`/gt3x/archiv/${key}/standings/pro`}>Standings</Link>
                </div>
            </div>

            <Incidents seasonKey={key} />
        </>
    );
}
